module.exports = __webpack_public_path__ + "img/info_icon.5d1a06b8.svg";